export const actionCellSx = (theme) => ({
  marginTop: theme.spacing(0.5),
  padding: "0 !important",
  ":hover": {
    backgroundColor: "unset",
  },
});

export const disabledActionCellSx = (theme) => ({
  marginTop: theme.spacing(0.5),
  padding: "0 !important",
  color: `${theme.palette.grey[300]} !important`,
  ":hover": {
    backgroundColor: "unset",
  },
});
